import type { BenefitDetailDto, BenefitQuestionnaireDto } from "./benefit-types"

export function questionnaireAnswers(benefit: BenefitDetailDto): BenefitQuestionnaireDto {
  return benefit.questionnaire ?? {
    pse: benefit.pseBenefitDetails ? { interestedInPastDueForgivenessProgram: benefit.pseBenefitDetails.isInterestedInPastDueBillForgiveness } : null,
    liheap: benefit.liheapBenefitDetails ? {
      lifeThreateningEnergyCrisis: benefit.liheapBenefitDetails.isLifeThreateningEnergyCrisis,
      rentalPastDue: benefit.liheapBenefitDetails.rentAmountPastDue,
      waterPastDue: benefit.liheapBenefitDetails.waterAmountPastDue,
      coolingCost: benefit.liheapBenefitDetails.coolingCost,
    } : null,
    sheap: benefit.sheapBenefitDetails ? {
      furnaceOlderThanFiveYears: benefit.sheapBenefitDetails.isFurnaceOlderThan5Years,
      furnaceUsedToHeatHome: benefit.sheapBenefitDetails.isFurnaceUsedToHeatTheHome,
    } : null,
  }
}

export function parseQuestionnaireAmount(value: string): number | null {
  if (value.trim() === "") return null
  const amount = Number(value)
  return Number.isFinite(amount) && amount >= 0 ? amount : null
}
